/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Download_CompleteInputs */



/**
* | output |
* | --- |
* | "Batch download complete." |
*
* @param {Batch_Download_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_download_complete = /** @type {((inputs?: Batch_Download_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Download_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléchargement par lots terminé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Batch-Download abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Download in batch completato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка пакета завершена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descarga por lotes completada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量下载完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一括ダウンロードが完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच डाउनलोड पूरा हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Download em lote concluído.")
	return /** @type {LocalizedString} */ ("Batch download complete.")
});